import script from "./AboutUsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUsView.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUsView.vue?vue&type=style&index=0&id=f241d5f6&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f241d5f6"]])

export default __exports__